export default __webpack_public_path__ + "static/media/Kalocsai_Flowers.b9887e1b.ttf";